import PropTypes from 'prop-types';
import React from 'react';

import callFrameSelector from '../../../../selectors/testOverview/testComponents/zoomTestCallCheck/CallFrameSelector';
import { t } from '../../../../services/i18nService';
import useVideoChatController from '../../../../services/remoteOralExam/useVideoChatController';

import styles from '../../testOverview.scss';

const CallFramePure = React.memo(({ frameSrc }) => {
    useVideoChatController(frameSrc);

    return (<div className={styles.videoContainer}>
        <div className={styles.videoWrapper}>
            <iframe
                title={t('remoteOralExam.inProgress.videoCallTitle')}
                className={styles.zoomIntegration}
                src={frameSrc}
                allow="cross-origin-isolated"
            />
        </div>
    </div>);
});

CallFramePure.propTypes = {
    frameSrc: PropTypes.string.isRequired,
};

const CallFrame = React.memo((props) => {
    const newProps = callFrameSelector.mapPropsToProps(props);

    return <CallFramePure {...props} {...newProps} />;
});

CallFrame.propTypes = {
    credentials: PropTypes.object,
};

export default CallFrame;
